export default __webpack_public_path__ + "static/media/Diarmad's Respect.142aed88.jpg";